import { toWords } from 'number-to-words';

export const toWordsPrice = (num) => {
  const units = [
    "", "Thousand", "Lakh", "Crore"
  ];

  let words = '';
  let i = 0;

  while (num > 0) {
    let part = num % 1000;

    if (part !== 0) {
      let partWord = toWords(part);
      words = partWord + ' ' + (units[i] ? units[i] : '') + ' ' + words;
    }

    num = Math.floor(num / 1000);
    i++;
  }

  return words.trim();
};

